import _ from 'lodash'
import store from '../store'
import * as types from '../store/types'

const skipToAccept = (to, from, next) => {
    if (_.has(store.getters[types.users.modules.current.getters.item], 'data')) {
        next({
            name: 'residencies.accept.store',
            params: {
                token: to.params.token
            }
        })
    }

    next()
}

export default [
    {
        path: '/residencies/:token',
        component: require('../components/the-layout-card').default,
        props: route => {
            return {
                maxW: [
                    'residencies.welcome.show'
                ].includes(route.name)
                    ? 'max-w-sm'
                    : 'max-w-xs'
            }
        },
        children: [
            {
                path: '',
                name: 'residencies.show',
                redirect: {
                    name: 'residencies.welcome.show'
                }
            },
            {
                path: 'accept',
                name: 'residencies.accept.store',
                components: {
                    default: require('../views/residencies/accept/store').default,
                    header: require('../views/residencies/steps').default
                }
            },
            {
                path: 'login',
                name: 'residencies.sessions.create',
                beforeEnter: skipToAccept,
                components: {
                    default: require('../views/residencies/sessions/create').default,
                    header: require('../views/residencies/steps').default,
                    below: {
                        render (createElement) {
                            return createElement('router-link', {
                                attrs: {
                                    to: { name: 'residencies.users.create' }
                                },
                                class: 'text-center no-underline text-grey-darker'
                            }, [
                                "Don't have an account? ",
                                createElement('span', { class: 'text-blue' }, 'Create Account')
                            ])
                        }
                    }
                }
            },
            {
                path: 'create-account',
                name: 'residencies.users.create',
                beforeEnter: skipToAccept,
                components: {
                    default: require('../views/residencies/users/create').default,
                    header: require('../views/residencies/steps').default,
                    below: {
                        render (createElement) {
                            return createElement('router-link', {
                                attrs: {
                                    to: { name: 'residencies.sessions.create' }
                                },
                                class: 'text-center no-underline text-grey-darker'
                            }, [
                                'Already have an account? ',
                                createElement('span', { class: 'text-blue' }, 'Sign in')
                            ])
                        }
                    }
                }
            },
            {
                path: 'welcome',
                name: 'residencies.welcome.show',
                components: {
                    default: require('../views/residencies/welcome/show').default,
                    header: require('../views/residencies/steps').default
                }
            }
        ]
    }
]
